export const API_BASE_URL = '/api/';



// WEBPACK FOOTER //
// ./configs/qa.js